import { Layout } from "antd";
import styled from "styled-components";

export const LayoutHeader = styled(Layout.Header)`
  height: 64px;
  padding: 0 32px;
  background: var(--veloprime-bg-alternative);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--veloprime-text-secondary);

  span {
    display: flex;
  }

  .ant-btn.menu-button {
    border-radius: 4px;
    background-color: var(--veloprime-deep-navy) !important;
    border-color: var(--veloprime-deep-navy) !important;
    height: 48px;
    width: 48px;
    
    svg {
      width: 20px;
      height: 20px;
      margin: 0;
      fill: var(--veloprime-text-primary);
    }
    
    &:hover {
      background-color: #1a2a3e !important;
      border-color: var(--veloprime-deep-navy) !important;
    }
  }

  @media only screen and (max-device-width: 812px) {
    z-index: 2;
    padding: 0 24px;
    column-gap: 8px;
    justify-content: space-between;
    box-shadow: rgba(15, 26, 46, 0.16) 0px 0px 16px 0px;
    height: 56px;
    
    .ant-btn.menu-button {
      height: 40px;
      width: 40px;
      
      svg {
        width: 18px;
        height: 18px;
      }
    }
  }
`;
